import React from "react";
import { TFunction } from "i18next";
import classnames from "classnames";
import { useDispatch } from "react-redux";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

import { AppDispatch } from "../../../../redux/store";
import { setIsAssociateModalOpened } from "../../../../redux/slices/fidelitySlice";

import { ActionColumnWrapper } from "./ActionColumnWrapper";

type Props = {
    modify: boolean;
    isFidelityArchived: boolean;
    isShopSelected: boolean;
    selectedRows: any[];
    setIsFidelityArchived: (v: boolean) => void;
    setLocalFilterActive: (v: boolean) => void;
    setLimit: (v: number) => void;
    setGlobalDataIsUpdated: (v: boolean | number) => void;
    t: TFunction;
};

export default function TableToolbar({
    modify,
    isFidelityArchived,
    isShopSelected,
    selectedRows,
    setIsFidelityArchived,
    setLocalFilterActive,
    setLimit,
    setGlobalDataIsUpdated,
    t,
}: Props) {
    const dispatch = useDispatch<AppDispatch>();
    const handleAffect = () => {
        dispatch(setIsAssociateModalOpened(true));
        setLocalFilterActive(false);
    };

    return (
        <React.Fragment>
            {modify === true ? (
                <div className="d-flex justify-content-start align-items-center">
                    <CustomMainColorButton
                        data-testid="fidelity-shops-affect-button"
                        className={classnames(
                            "w-100 ml-3 fed_btn_BTassignLoyalty",
                            { "not-allowed-icon__clz": isFidelityArchived }
                        )}
                        rounded
                        variant="primary"
                        disabled={!isShopSelected}
                        onClick={handleAffect}
                    >
                        {t("Affect fidelity")}
                    </CustomMainColorButton>
                </div>
            ) : null}
            <ActionColumnWrapper
                selectedRows={selectedRows}
                setDataIsUpdated={setGlobalDataIsUpdated}
                isFidelityArchived={isFidelityArchived}
                setIsFidelityArchived={setIsFidelityArchived}
                setLimit={setLimit}
            />
        </React.Fragment>
    );
}
